module.exports = function getResource(label, vars = []) {
    let resources = { remove: 'Supprimer' };
    return resources[label];
};
